import React from "react";
import { type GridMetricKey, type MetricScale, METRIC_UNITS, ANNUAL_METRIC_UNITS } from "../../../api/grid";

interface ColorLegendProps {
  metric: GridMetricKey;
  min: number;
  max: number;
  scale?: MetricScale;
}

function formatValue(v: number, metric: GridMetricKey): string {
  if (metric === "carbon_intensity_kg_per_mwh") {
    return v.toFixed(0);
  }
  if (Math.abs(v) < 0.01 && v !== 0) {
    return v.toExponential(1);
  }
  return v.toFixed(2);
}

const ColorLegend: React.FC<ColorLegendProps> = ({ metric, min, max, scale }) => {
  const units = scale === "annual" ? ANNUAL_METRIC_UNITS : METRIC_UNITS;
  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-surface-800/90 backdrop-blur-sm rounded-lg border border-border/50">
      <span className="text-caption text-text-secondary whitespace-nowrap">
        {formatValue(min, metric)}
      </span>
      <div
        className="h-3 w-40 rounded-full"
        style={{
          background:
            "linear-gradient(to right, rgb(46,204,113), rgb(241,196,15), rgb(231,76,60))",
        }}
      />
      <span className="text-caption text-text-secondary whitespace-nowrap">
        {formatValue(max, metric)}
      </span>
      <span className="text-caption text-text-muted ml-1">
        {units[metric]}
      </span>
    </div>
  );
};

export default ColorLegend;
